<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg', headerClass: 'type-2' }")
    .wrap
      template(v-if="step === 1")
        .warning
          icon.icon(name="exclamation-triangle" width="50" height="50")
          span ※ {{$t('device_page.public_access_warning')}} ※
        .box
          .msg(v-html="$options.filters.nl2br(functionSet.public_place_alert)")
        .modal-footer
          b-btn(size="sm" variant="primary" @click="next" pill) {{$t('agree_and_connect')}}
          b-btn(size="sm" @click="visible = false" pill) {{$t('agree_and_connect')}}
      template(v-if="step === 2")
        .title {{$t('security_agreement')}}
        .content(v-html="$options.filters.nl2br(contract.content)")
        .modal-footer
          b-btn(size="sm" variant="primary" @click="next" pill) {{$t('agree_and_connect')}}
          b-btn(size="sm" @click="visible = false" pill) {{$t('agree_and_connect')}}
</template>

<script>
import { SecurityAgreementAPI, ColumnReturnAPI } from "@/api"
import Dialogs from "@/components/mixins/dialog/index.vue"
import _ from "lodash"

export default {
  name: "dialogAccess",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Dialogs,
  },
  filters: {
    nl2br(value) {
      if (value === null) return ""
      return value.replace(/\n/g, "<br/>")
    },
  },
  watch: {
    async show(newVal) {
      if (newVal) {
        await this.fetchData()
      }
      this.visible = newVal
    },
    visible(newVal) {
      this.step = this.functionSet.flag_public_place_alert === 1 ? 1 : this.functionSet.flag_security_agreement === 1 ? 2 : 3
      this.$emit("update:show", newVal)
    },
    async step(newVal) {
      if (newVal === 2) {
        await this.fetchContract()
      } else if (newVal === 3) {
        this.$emit("complate")
      }
    },
  },
  data() {
    return {
      visible: false,
      step: 1,
      functionSet: {
        flag_public_place_alert: 0,
        flag_security_agreement: 0,
        public_place_alert: "",
        security_agreement_version: "1.3",
      },
      contract: {
        content: null,
      },
    }
  },
  methods: {
    async fetchData() {
      const params = {
        table_name: "CompanyFunction",
        column_name: ["flag_public_place_alert", "public_place_alert", "flag_security_agreement", "security_agreement_version"],
      }
      const res = await ColumnReturnAPI.post("", params)
      this.functionSet = res.data.objects
    },
    async fetchContract() {
      const res = await SecurityAgreementAPI.get()
      this.contract = _.find(res.data.objects, { security_agreement_version: this.functionSet.security_agreement_version })
    },
    async next() {
      if (this.step === 1) {
        if (this.functionSet.flag_security_agreement === 1) {
          this.step = 2
          return
        }
        this.$emit("complate")
      } else {
        this.$emit("complate")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 30px;
}
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
h1 {
  font-size: 20px;
}
.title {
  font-size: 19px;
  text-align: center;
  padding-bottom: 20px;
}
.content {
  padding: 0 0 20px;
}
.btn-secondary {
  color: #6f6f6f;
  border-color: #6f6f6f;
  background-color: #fff;
  text-align: center;
}
.btns.text-center {
  margin-top: 20px;

  button {
    min-width: 60px;
  }

  button + button {
    margin-left: 10px;
  }
}
</style>
